module.exports = __webpack_public_path__ + "static/media/read-time.7a8e056c.svg";